/**
 * HTTP adapter
 */
import config from "./config";
import http from "./http";
import Constant from "@/Constant";
import { util, storage } from "@common/utils/util";
import axios from "@service/axios";

export default function jsonCall(
  { fn, param, fullresult, method },
  option,
  success,
  error
) {
  method = method || "post";
  let axiosConfig = Object.assign({}, util.deepCopy(config), option);
  if (method.toString().toLowerCase() === "post") {
    return http.post({ fn, param, fullresult }, axiosConfig, success, error);
  } else {
    return http.get({ fn, param, fullresult }, axiosConfig, success, error);
  }
}

/**
 * 常规RESTfull接口调用
 *
 * @param      {String}    url      请求URL地址
 * @param      {Object}    data     请求数据
 * @param      {Function}  success  请求成功回调
 * @param      {Function}  error    请求失败回调
 */
export const restCall = function (url, data, type, success, error) {
  if (!data.userAttrId) {
    data.userAttrId = util.storage.session.get("userAttrId");
  }

  let axiosConfig = util.deepCopy(config);
  axiosConfig.baseURL = url;
  axiosConfig.data = data;
  axiosConfig.method = type || "POST";

  // 非生产环境，打印调试URL
  if (Constant.env.NODE_ENV != "production" && Constant.env.PRINT_DEBUG_URL) {
    let httpURL = util.combHttpURL(axiosConfig.baseURL, data);
    console.log("请求URL: ", httpURL);
  }

  return axios
    .request(axiosConfig)
    .then((res) => {
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return Promise.reject("请求服务异常！");
      }

      let result =
        typeof res.data == "string" ? JSON.parse(res.data) : res.data;
      if (result["success"] === true) {
        success && success(result);
        return Promise.resolve(result);
      } else {
        error && error(result);
        return Promise.reject(result);
      }
    })
    .catch((errors) => {
      if (util.isObject(errors)) {
        error &&
          error(
            errors.message ||
              (errors.target && errors.target.message) ||
              "网络请求异常,请稍后再试!"
          );
        return Promise.reject(
          errors.message ||
            (errors.target && errors.target.message) ||
            "网络请求异常,请稍后再试!"
        );
      } else {
        error && error(errors);
        return Promise.reject(errors);
      }
    });
};

/**
 * 常规RESTfull接口调用
 *
 * @param      {String}    url      请求URL地址
 * @param      {Object}    data     请求数据
 * @param      {Function}  success  请求成功回调
 * @param      {Function}  error    请求失败回调
 */
export const tokenCall = function (url, data, type, token, success, error) {
  let axiosConfig = util.deepCopy(config);
  axiosConfig.method = type || "POST";
  axiosConfig.baseURL = (url.startsWith('http://') || url.startsWith('https://')) ? url : Constant.tokenCallUrl + url;
  if (axiosConfig.method.toLowerCase().trim() == "get") {
    axiosConfig.params = data;
  } else {
    axiosConfig.data = data;
  }
  //判断属于哪个模块登录customerService：售后登录
  let belong = util.storage.local.get("belong");
  let _token = "";
  switch (belong) {
    case "fitting":
      _token = token || util.storage.local.get("fittingToken");
      break;
    default:
      _token = token || util.storage.local.get("token");
      break;
  }
  axiosConfig.headers.token = _token;
  // axiosConfig.headers.token = token || util.storage.local.get("token");
  axiosConfig.headers["Content-Type"] = "application/json;charset=UTF-8";
  axiosConfig.transformRequest = [
    function (data) {
      // console.log('transformRequest<--------------------',data,typeof data,JSON.stringify(data))
      return JSON.stringify(data);
    },
  ];

  // console.log('===============', axiosConfig)

  return axios
    .request(axiosConfig)
    .then((res) => {
      console.log("tokenCall >>>>>>>>>>>>>>>", res);
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return Promise.reject("请求服务异常！");
      }

      let result =
        typeof res.data == "string" ? JSON.parse(res.data) : res.data;

      if (result["code"] === 200) {
        console.log(result);
        success && success(result);
        return Promise.resolve(result);
      } else {
        error && error(result);
        return Promise.reject(result);
      }
    })
    .catch((errors) => {
      if (util.isObject(errors)) {
        error &&
          error(errors.message || errors.target || "网络请求异常,请稍后再试!");
        return Promise.reject(
          errors.message || errors.target || "网络请求异常,请稍后再试!"
        );
      } else {
        error && error(errors);
        return Promise.reject(errors);
      }
    });
};



// WEBPACK FOOTER //
// ./src/service/adapter.js